import Countdown from "react-countdown"


function CountdownComponent({date, serverTime, setServerTime, clientTime, setClientTime, onComplete,setIsTime,setIsAlmostDown, setShowExtraTime, 
    minutsTotal, setShowBtnConsultaFallida, checkingCF, setCheckingCF}){


    const handleNow = () => {
        return serverTime;
    }
    const onTick = ({hours, minutes, seconds }) =>{
        let now = Date.now();
        setServerTime(serverTime + (now - clientTime))
        setClientTime(now)

        if(hours===0 && minutes < 5){
            setIsTime(false)
            setIsAlmostDown(true)        
            setShowExtraTime(true)             
        }

        //check el btn para la consulta fallida
        let currentMinuts = hours * 60 + minutes
        if(minutsTotal - currentMinuts >= 11){
            
            if(!checkingCF){
                console.log('pasaron 10min')
                setShowBtnConsultaFallida(true)
                setCheckingCF(true)
            }
            
        }
    }
    const renderer = ({ hours, minutes, seconds,completed }) => {
        return <span>{hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>        
    };

    return(
        <Countdown 
            date={date} 
            renderer={renderer} 
            onTick={onTick}
            now={handleNow}
            onComplete={onComplete}
        />
    )
}

export default CountdownComponent